var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"planAlokasiChart",staticClass:"planAlokasiChart",staticStyle:{"width":"100%","height":"500px"}})
}
var staticRenderFns = []

export { render, staticRenderFns }